/**
 * components/controls/BulkActions.jsx
 *
 * Options switch based on the active status filter:
 *   Trash view  →  Restore | Delete Permanently
 *   Normal view →  Set Published | Set Draft | Move to Trash
 */

import { __ } from "@wordpress/i18n";
import { useState } from "@wordpress/element";
import { ChevronDown } from "lucide-react";
import { useCrudListState } from "../../context/CrudContext";

export default function BulkActions({
    onBulkTrash,
    onBulkRestore,
    onBulkPermanentDelete,
    onBulkStatus,
}) {
    const { selected, status: activeFilter } = useCrudListState();
    const [bulkAction, setBulkAction] = useState("none");

    const isTrashView = activeFilter === "trash";

    const apply = () => {
        if (bulkAction === "none" || selected.length === 0) return;

        switch (bulkAction) {
            case "trash":
                onBulkTrash(selected);
                break;
            case "restore":
                onBulkRestore(selected);
                break;
            case "delete_forever":
                onBulkPermanentDelete(selected);
                break;
            default:
                onBulkStatus(selected, bulkAction);
        }

        setBulkAction("none");
    };

    return (
        <div className="flex items-center space-x-2">
            <select
                value={bulkAction}
                onChange={(e) => setBulkAction(e.target.value)}
                className="w-full bg-white hover:text-inherit border border-gray-200 rounded-md ps-3 pe-8 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-accent"
            >
                <option value="none">{__("Bulk Actions", "wpbean-product-gallery-slider-for-woocommerce")}</option>

                {isTrashView ? (
                    <>
                        <option value="restore">{__("Restore", "wpbean-product-gallery-slider-for-woocommerce")}</option>
                        <option value="delete_forever">
                            {__("Delete Permanently", "wpbean-product-gallery-slider-for-woocommerce")}
                        </option>
                    </>
                ) : (
                    <>
                        <option value="publish">{__("Set Published", "wpbean-product-gallery-slider-for-woocommerce")}</option>
                        <option value="draft">{__("Set Draft", "wpbean-product-gallery-slider-for-woocommerce")}</option>
                        <option value="trash">{__("Move to Trash", "wpbean-product-gallery-slider-for-woocommerce")}</option>
                    </>
                )}
            </select>
            <button
                onClick={apply}
                disabled={bulkAction === "none"}
                className="px-3 py-2 bg-gray-200/80 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-300/80 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
                {__("Apply", "wpbean-product-gallery-slider-for-woocommerce")}
            </button>
        </div>
    );
}
